export default "__VITE_ASSET__D6ooATlq__"